import React from "react";
import cst from "../assets/images/cst.webp";
import Rightarrow from "../assets/icons/Rightarrow";
import { Link } from "react-router-dom";
import { t } from "i18next";
const CustomAd = () => {
  return (
    <section className="bg_image_yellow">
      <div className="wrapper">
        <div className="faq_grid cst_add_grid">
          <div className="cst_ad_content">
            <h2 className="subtitle_common">
              {t("where_every_meal_is_a")}
              <span className="text-primary"> {t("delivery_delight")}</span>
            </h2>
            <p className="para_common">
              {t("at_loadinn")}
            </p>
            <p className="para_common">
              {t("elevate_your_day_with_every_bite")}
            </p>
            <Link to="#" className="btn btn-primary">
              {t("order_now")} <Rightarrow />
            </Link>
          </div>
          <div className="cst_img">
            <img src={cst} alt="cst image" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomAd;
